import { useContentIntelligence } from '../api';
import { ModerationIntelligenceCard } from '@/features/moderation/components/ModerationIntelligenceCard';
import { ModerationStateCard } from '@/features/moderation/components/ModerationStateCard';

/**
 * Displays Coop moderation intelligence for a content item.
 * Reuses the moderation feature's IntelligenceCard and StateCard components.
 * Fetches via shared useContentIntelligence (same cache as overview strip / description).
 *
 * Layout: side-by-side Coop scan (snapshot) + Coop intelligence (signals / rules).
 * Verdict reason is omitted here — ContentDescriptionCard already surfaces the AI summary.
 */
export function ContentCoopIntelligenceCard({
  contentId,
  postStatus,
  moderationStatus,
}: {
  contentId: string;
  postStatus?: string | null;
  moderationStatus?: string | null;
}) {
  const id = Number(contentId);
  const pollWhileMissing =
    (moderationStatus ?? '').trim().toUpperCase() === 'PENDING';
  const { data: intelligence, isLoading, isError } = useContentIntelligence(contentId, {
    pollWhileMissing,
  });

  const shared = isError ? null : (intelligence ?? null);

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <ModerationStateCard
        postId={id}
        intelligence={shared}
        postStatus={postStatus}
        isLoading={isLoading}
        moderationStatus={moderationStatus}
        hideVerdictReason
      />
      <ModerationIntelligenceCard
        intelligence={shared}
        isLoading={isLoading}
        moderationStatus={moderationStatus}
        hideVerdictReason
      />
    </div>
  );
}
